import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './LeadDashboardList.css'

const LeadDashboardListUI = ({ context, leadDashboardList,
  originatorList, salesChannelList, onRefreshClick,
  onCreateEntryClick, onUpdateEntryClick, onSendEmailClick
}) =>
  <div className='su_ld_dash'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI context={context}
          onRefreshClick={onRefreshClick}
          onCreateEntryClick={onCreateEntryClick}
        />
      }
      right={<span />}
    />

    <div className='g_flex_h g_m_bottom_50'>
      <span>{leadDashboardList.length} entr{leadDashboardList.length === 1 ? 'y' : 'ies'} displayed</span>
    </div>

    <CardUI className='scard'>
      <div className='ld_table_wrapper'>
        <table className='table_cr table ld_table'>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Company</th>
              <th>Date of Lead</th>
              <th>Comments</th>
              <th>Loan Amount</th>
              <th>POC (Client End)</th>
              <th>Designation</th>
              <th>Phone No.</th>
              <th>E-Mail</th>
              <th>Originator</th>
              <th>Channel</th>
              <th>Send New Communication</th>
              <th>Follow Up (Date)</th>
              <th>Client Activity</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              leadDashboardList.length > 0 ? (
                leadDashboardList.map((entry, i) =>
                  <EntryRowUI key={entry.leadDashboardId || i} rowNumber={i + 1} entry={entry}
                    originatorList={originatorList}
                    salesChannelList={salesChannelList}
                    onUpdateEntryClick={onUpdateEntryClick}
                    onSendEmailClick={onSendEmailClick}
                  />
                )
              ) : (
                <tr>
                  <td colSpan='15' className='g_text_center g_muted'>No entries yet</td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </CardUI>
  </div>

const EntryRowUI = ({ rowNumber, entry, originatorList, salesChannelList, onUpdateEntryClick, onSendEmailClick }) => {
  let originator = (originatorList || []).find(o => o.key === entry.originatorUserId)
  let channel = (salesChannelList || []).find(c => c.key === entry.channel)

  return (
    <tr>
      <td>{rowNumber}</td>
      <td>
        {
          entry.accountId && !entry.accountNotFound
            ? <Link to={`/su/accounts/${entry.accountId}/kyc`} className='g_link'><b>{entry.accountName}</b></Link>
            : <b>{entry.brandName || entry.accountNamePan}</b>
        }
        {
          !entry.accountId && entry.suggestedAccountId &&
          <div className='g_muted g_small'>Possible match: {entry.suggestedAccountName}</div>
        }
        {
          entry.accountNotFound &&
          <div className='g_muted g_small'>Account not found (ID: {entry.accountId})</div>
        }
      </td>
      <td>{entry.dateCreated ? new Date(entry.dateCreated).toLocaleDateString('en-IN') : '-'}</td>
      <td>{entry.comments || '-'}</td>
      <td>{entry.manualLoanAmount ? `₹${entry.manualLoanAmount.toLocaleString('en-IN')}` : '-'}</td>
      <td>{entry.poc || '-'}</td>
      <td>{entry.designation || '-'}</td>
      <td>{entry.phoneNumber || '-'}</td>
      <td>{entry.email || '-'}</td>
      <td>{originator ? originator.value : '-'}</td>
      <td>{channel ? channel.value : '-'}</td>
      <td className='g_text_center'>
        <span className='icon icon-envelope-o g_cursor_pointer'
          data-lead-dashboard-id={entry.leadDashboardId || ''}
          data-account-id={entry.accountId || ''}
          onClick={onSendEmailClick}
        />
      </td>
      <td>{entry.followUpDate ? new Date(entry.followUpDate).toLocaleDateString('en-IN') : '-'}</td>
      <td>{entry.clientActivity ? (entry.clientActivity === 'active' ? 'Active' : 'Passive') : '-'}</td>
      <td className='g_text_center'>
        <span className='icon icon-pencil g_cursor_pointer'
          data-lead-dashboard-id={entry.leadDashboardId || ''}
          data-account-id={entry.accountId || ''}
          onClick={onUpdateEntryClick}
        />
      </td>
    </tr>
  )
}

const ActionLeftUI = ({ context, onRefreshClick, onCreateEntryClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-plus' onClick={onCreateEntryClick} />
    <span className='g_m_left_100 g_large'><b>Lead Dashboard</b></span>
  </div>

export default LeadDashboardListUI